
import Vue from 'vue';
import '@/assets/css/helpdesk/helpdesk-theme.css';
import Component from 'vue-class-component';
import {namespace} from 'vuex-class';
import PaginationBar from '@/components/shared/PaginationBar.vue';
import GmailLogo from '@/components/helpdesk/GmailLogo.vue';
import {IGmailAccount} from '@/store/modules/helpdeskAccountsModule';

const mod = namespace('helpdeskAccountsModule');

@Component({
  name: 'HelpdeskAccounts',
  components: {PaginationBar, GmailLogo},
})
export default class HelpdeskAccounts extends Vue {
  @mod.Getter('accounts')    private accounts!: IGmailAccount[];
  @mod.Getter('currentPage') private currentPage!: number;
  @mod.Getter('lastPage')    private lastPage!: number;
  @mod.Getter('total')       private total!: number;
  @mod.Getter('perPage')     private perPage!: number;
  @mod.Getter('oauthUrl')    private oauthUrl!: string | null;

  private confirmDelete = false;
  private deleteTarget: IGmailAccount | null = null;
  private subscribes: any = {};
  private selectedPerPage = 15;
  private syncing = false;
  private snackbar = false;
  private snackbarText = '';
  private snackbarColor = 'success';

  created() {
    this.subscribes = this.$ons({
      'backend.call.OK.accountsLoaded': () => {},
      'backend.call.KO.accountsLoaded': () => {},
      'backend.call.OK.accountDeleted': () => { this.loadData(); },
      'backend.call.OK.oauthUrlLoaded': () => { this.openOAuthPopup(); },
      'backend.call.OK.syncDone': (payload: any) => {
        this.syncing = false;
        const synced = payload && payload.synced !== undefined ? payload.synced : 0;
        this.showSnackbar('success', synced + ' emails importados correctamente.');
        this.loadData();
      },
      'backend.call.KO.syncDone': () => {
        this.syncing = false;
        this.showSnackbar('error', 'Error al sincronizar emails.');
      },
    });
    this.loadData();
  }

  beforeDestroy() { this.$offs(this.subscribes); }

  loadData() {
    this.$store.dispatch('helpdeskAccountsModule/fetchAccounts', {
      page: this.currentPage,
      per_page: this.selectedPerPage,
    });
  }

  private onPageChange(page: number) {
    this.$store.dispatch('helpdeskAccountsModule/fetchAccounts', {
      page,
      per_page: this.selectedPerPage,
    });
  }

  private onPerPageChange(value: number) {
    this.selectedPerPage = value;
    this.loadData();
  }

  private onDelete(item: IGmailAccount) {
    this.deleteTarget = item;
    this.confirmDelete = true;
  }

  private doDelete() {
    if (!this.deleteTarget) return;
    this.confirmDelete = false;
    this.$store.dispatch('helpdeskAccountsModule/deleteAccount', this.deleteTarget.id);
  }

  private onSync() {
    this.syncing = true;
    this.$store.dispatch('helpdeskAccountsModule/syncEmails');
  }

  private onConnectGmail() {
    this.$store.dispatch('helpdeskAccountsModule/getOAuthUrl');
  }

  private openOAuthPopup() {
    const url = this.oauthUrl;
    if (!url) return;

    const popup = window.open(url, 'gmail_oauth', 'width=600,height=700,left=200,top=100');

    const handler = (event: MessageEvent) => {
      // Only trust the OAuth popup we opened, not any other window posting messages.
      if (!popup || event.source !== popup) return;
      if (!event.data || typeof event.data !== 'object') return;
      window.removeEventListener('message', handler);
      if (popup) { popup.close(); }

      if (event.data.success) {
        this.showSnackbar('success', 'Cuenta ' + event.data.data + ' conectada correctamente.');
        this.loadData();
      } else {
        this.showSnackbar('error', 'Error al conectar: ' + event.data.data);
      }
    };

    window.addEventListener('message', handler);
  }

  private showSnackbar(color: string, text: string) {
    this.snackbarColor = color;
    this.snackbarText  = text;
    this.snackbar      = true;
  }

  private isExpired(date: string) {
    return new Date(date) < new Date();
  }

  private formatDate(date: string): string {
    if (!date) return '—';
    const d = new Date(date);
    return d.toLocaleDateString('es-ES', {day: 'numeric', month: 'short', year: 'numeric'}) +
      ' ' + d.toLocaleTimeString('es-ES', {hour: '2-digit', minute: '2-digit'});
  }
}
